<div class="password-change-container">
  <div class="header" [class.forced]="isForced">
    <div class="warning-icon" [class.forced]="isForced">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <h2 mat-dialog-title class="title" [class.forced]="isForced">{{ title }}</h2>
    <p class="message">{{ message }}</p>
  </div>

  <mat-dialog-content>
    <form [formGroup]="updatePasswordFormControl" (ngSubmit)="onSubmitPasswordForm()">
      <div class="form-fields">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Contraseña actual</mat-label>
          <input matInput formControlName="currentPassword" #currentPasswordInput 
                 [type]="hideActual() ? 'password' : 'text'" 
                 [disabled]="fetchingUpdatePassword" />
          <button mat-icon-button type="button" matSuffix 
                  (mousedown)="toggleVisibility(hideActual, $event)"
                  (mouseup)="toggleVisibility(hideActual, $event)" 
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideActual()"
                  [disabled]="fetchingUpdatePassword">
            <mat-icon>{{hideActual() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Nueva contraseña</mat-label>
          <input matInput formControlName="newPassword" 
                 [type]="hideNueva() ? 'password' : 'text'"
                 [disabled]="fetchingUpdatePassword" />
          <button mat-icon-button type="button" matSuffix 
                  (mousedown)="toggleVisibility(hideNueva, $event)"
                  (mouseup)="toggleVisibility(hideNueva, $event)" 
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideNueva()"
                  [disabled]="fetchingUpdatePassword">
            <mat-icon>{{hideNueva() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Confirmar contraseña</mat-label>
          <input matInput formControlName="confirmPassword" 
                 [type]="hideConfirmar() ? 'password' : 'text'"
                 [disabled]="fetchingUpdatePassword" />
          <button mat-icon-button type="button" matSuffix 
                  (mousedown)="toggleVisibility(hideConfirmar, $event)"
                  (mouseup)="toggleVisibility(hideConfirmar, $event)" 
                  [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hideConfirmar()"
                  [disabled]="fetchingUpdatePassword">
            <mat-icon>{{hideConfirmar() ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
        </mat-form-field>

        @if (incorrectPasswordError) {
          <mat-error class="error-message">La contraseña actual es incorrecta</mat-error>
        }

        @if (updatePasswordFormControl.hasError('passwordMismatch')) {
          <mat-error class="error-message">Las contraseñas no coinciden</mat-error>
        }

        @if (submitted && updatePasswordFormControl.get('currentPassword')?.value && updatePasswordFormControl.get('newPassword')?.value && updatePasswordFormControl.get('currentPassword')?.value === updatePasswordFormControl.get('newPassword')?.value) {
          <mat-error class="error-message">La nueva contraseña no puede ser igual a la actual</mat-error>
        }

        <div class="password-requirements">
          <p class="requirements-title">
            <mat-icon>info</mat-icon>
            Requisitos de la contraseña:
          </p>
          <ul>
            <li [class.valid]="!updatePasswordFormControl.get('newPassword')?.hasError('minLength') && updatePasswordFormControl.get('newPassword')?.value"
                [class.invalid]="updatePasswordFormControl.get('newPassword')?.hasError('minLength') && updatePasswordFormControl.get('newPassword')?.touched">
              <mat-icon class="requirement-icon">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('minLength') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Mínimo 10 caracteres
            </li>
            <li [class.valid]="!updatePasswordFormControl.get('newPassword')?.hasError('uppercase') && updatePasswordFormControl.get('newPassword')?.value"
                [class.invalid]="updatePasswordFormControl.get('newPassword')?.hasError('uppercase') && updatePasswordFormControl.get('newPassword')?.touched">
              <mat-icon class="requirement-icon">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('uppercase') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener letras mayúsculas
            </li>
            <li [class.valid]="!updatePasswordFormControl.get('newPassword')?.hasError('lowercase') && updatePasswordFormControl.get('newPassword')?.value"
                [class.invalid]="updatePasswordFormControl.get('newPassword')?.hasError('lowercase') && updatePasswordFormControl.get('newPassword')?.touched">
              <mat-icon class="requirement-icon">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('lowercase') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener letras minúsculas
            </li>
            <li [class.valid]="!updatePasswordFormControl.get('newPassword')?.hasError('number') && updatePasswordFormControl.get('newPassword')?.value"
                [class.invalid]="updatePasswordFormControl.get('newPassword')?.hasError('number') && updatePasswordFormControl.get('newPassword')?.touched">
              <mat-icon class="requirement-icon">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('number') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener al menos un número
            </li>
            <li [class.valid]="!updatePasswordFormControl.get('newPassword')?.hasError('specialChar') && updatePasswordFormControl.get('newPassword')?.value"
                [class.invalid]="updatePasswordFormControl.get('newPassword')?.hasError('specialChar') && updatePasswordFormControl.get('newPassword')?.touched">
              <mat-icon class="requirement-icon">
                {{ !updatePasswordFormControl.get('newPassword')?.hasError('specialChar') && updatePasswordFormControl.get('newPassword')?.value ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              Debe contener al menos un carácter especial (!@#$%^&*...)
            </li>
          </ul>
        </div>
      </div>

      <mat-dialog-actions>
        <button mat-raised-button color="primary" type="submit"
                [disabled]="!updatePasswordFormControl.valid || fetchingUpdatePassword"
                class="submit-button">
          @if (fetchingUpdatePassword) {
            <mat-spinner diameter="20"></mat-spinner>
          } @else {
            Cambiar contraseña
          }
        </button>
      </mat-dialog-actions>
    </form>
  </mat-dialog-content>
</div>
